import React from 'react'
import { convertIntoLakh } from '../UtilityComponents/UtilityFunction'
import { useState } from 'react';
import { useEffect } from 'react';

const BarGraphCostOfDelay = ({ IsDelayGraph, percent, amt, Msg }) => {
    const [height, setheight] = useState(0);

    //console.log(percent, amt, "BarGraph");

    useEffect(() => {
        setheight(0);

        let timer = setTimeout(() => {
            setheight(percent);
        }, 300);

        return () => clearTimeout(timer);
    }, [percent, amt]);

    return (
        <>
            <div className="CalcGraph CalcGraphCOD">
                <div className="GraphBar">
                    <div style={{ width: `${height * 2}px` }} className={`bar COD  ${IsDelayGraph ? "red-graph" : ""}`}></div>
                </div>
                <span>₹{convertIntoLakh(amt)}</span>
            </div>
            <p className="MsgTxt">{Msg}</p>
        </>
    )
}

export default BarGraphCostOfDelay;
